import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { instance, instanceMob } from "../../utils/utils";
import Popover from "../popover/popover";
import InlineModal from "../info-modal/infoModal";
import './styles.css';

const PreRegisterUserModal = ({
    show,
    onHide
}) => {
    const [formValues, setFormValues] = useState({});
    const [loading, setLoading] = useState(false);
    const [sending, setSending] = useState(false);
    const [locations, setLocations] = useState([]);
    const [memberships, setMemberships] = useState();
    const [plans, setPlans] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertConfig, setAlertConfig] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "plan_total_value") return;

        setFormValues((prev) => {
            let newValues = { ...prev, [name]: value };

            if (name === "plan") {
                const selectedPlan = plans.find((p) => p.id === Number(value));
                if (selectedPlan) {
                    newValues.plan_value = parseFloat(selectedPlan.price) || 0;
                    const discount = parseFloat(newValues.plan_discount) || 0;
                    const total = newValues.plan_value - (newValues.plan_value * discount / 100);
                    newValues.plan_total_value = total > 0 ? total : "0.00";
                }
            }

            if (name === "plan_value" || name === "plan_discount") {
                const planValue = parseFloat(newValues.plan_value) || 0;
                const discount = parseFloat(newValues.plan_discount) || 0;
                const total = planValue - (planValue * discount / 100);
                newValues.plan_total_value = total > 0 ? total : "0.00";
            }

            return newValues;
        });
    };


    const resetForm = () => {
        setFormValues({});
        setSending(false);
        setShowAlert(false);
        setAlertConfig(null);
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);

        try {
            if (!formValues.location || formValues.location === "-1") {
                setAlertConfig({
                    title: "Error de validación",
                    description: "Debes seleccionar una locación.",
                    primaryAction: { label: "Aceptar", onClick: () => setShowAlert(false) },
                });
                setShowAlert(true);
                setSending(false);
                return;
            }

            if (!formValues.email?.trim()) {
                setAlertConfig({
                    title: "Error de validación",
                    description: "El correo electrónico es obligatorio.",
                    primaryAction: { label: "Aceptar", onClick: () => setShowAlert(false) },
                });
                setShowAlert(true);
                setSending(false);
                return;
            }

            if (formValues.plan) {
                if (
                    !formValues.start_date ||
                    !formValues.payment ||
                    !formValues.payment_date ||
                    !formValues.plan_value ||
                    !formValues.plan_total_value ||
                    (Number(formValues.payment) === 50 && !formValues.other_payment?.trim())
                ) {
                    setAlertConfig({
                        title: "Error de validación",
                        description: "Si seleccionas un plan, debes completar la fecha de inicio y todos los datos de pago.",
                        primaryAction: { label: "Aceptar", onClick: () => setShowAlert(false) },
                    });
                    setShowAlert(true);
                    setSending(false);
                    return;
                }
            }

            const payload = new URLSearchParams({
                membership: formValues.membership || "",
                email: formValues.email || "",
                plan_id: formValues.plan || "",
                date: formatDate(formValues.start_date),
                payment: formValues.payment || "",
                payment_date: formatDate(formValues.payment_date),
                plan_value: formValues.plan_value || "",
                plan_discount: formValues.plan_discount || "",
                plan_total_value: formValues.plan_total_value || "",
                other_payment_method: formValues.other_payment || "",
                location_id: formValues.location || "",
            });

            await instance.post(
                "memberships/corp/company/members/preregister",
                payload,
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            );

            setAlertConfig({
                title: "Registro exitoso",
                description: "El usuario ha sido pre-registrado correctamente.",
                primaryAction: {
                    label: "Aceptar",
                    onClick: () => {
                        setShowAlert(false);
                        onHide();
                    },
                },
            });
            setShowAlert(true);

        } catch (err) {
            console.error(err);

            const errorResponse = err?.response?.data;
            let errorMessage = "Ocurrió un problema al registrar el usuario.";

            if (Array.isArray(errorResponse) && errorResponse.length > 0) {
                errorMessage = errorResponse[0];
            } else if (typeof errorResponse === "string") {
                errorMessage = errorResponse;
            } else if (errorResponse?.message) {
                errorMessage = errorResponse.message;
            }

            setAlertConfig({
                title: "Error",
                description: errorMessage,
                primaryAction: {
                    label: "Reintentar",
                    onClick: () => setShowAlert(false),
                },
            });
            setShowAlert(true);
        } finally {
            setSending(false);
        }
    };

    const getLocations = () => {
        instanceMob
            .get(`admin/location/list`)
            .then((res) => res.data)
            .then((data) => setLocations(data))
            .catch((err) => console.error(err));
    };

    const getMemberships = () => {
        instance
            .get("memberships/corp/memberships")
            .then((res) => res.data)
            .then((data) => {
                setMemberships(data);
            })
            .catch((err) => console.error(err));
    }

    const getPlans = () => {
        instanceMob
            .get(`admin/plan?no_paginate=True`)
            .then((res) => res.data)
            .then((data) => setPlans(data))
            .catch((err) => console.error(err));
    };

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            const [locs, membs, plns] = await Promise.all([
                instanceMob.get("admin/location/list").then((r) => r.data),
                instance.get("memberships/corp/memberships").then((r) => r.data),
                instanceMob.get("admin/plan?no_paginate=True").then((r) => r.data),
            ]);

            setLocations(locs || []);
            setMemberships(membs || []);
            setPlans(plns || []);
        } catch (err) {
            console.error("Error cargando datos iniciales:", err);
            setAlertConfig({
                title: "Error al cargar datos",
                description:
                    "No fue posible cargar las sedes, membresías y planes. Intenta nuevamente.",
                primaryAction: { label: "Aceptar", onClick: () => setShowAlert(false) },
            });
            setShowAlert(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getLocations();
        getMemberships();
        getPlans();
    }, []);

    useEffect(() => {
        if (show) {
            resetForm();
            void fetchInitialData();
        } else {
            resetForm();
        }
    }, [show]);

    return (
        <>
            <Modal show={show} onHide={onHide} scrollable centered className="pre-register-user">
                <Modal.Header className="position-relative text-center justify-content-center">
                    <span className="text-center w-100 pre-register-user-title">Nuevo <strong>Usuario</strong></span>
                    <div className="position-absolute end-0 top-50 translate-middle-y me-3">
                        <svg
                            type="button"
                            className="btn-close pre-register-user-close"
                            aria-label="Close"
                            onClick={onHide}
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="27"
                            viewBox="0 0 26 27"
                            fill="none"
                        >
                            <path
                                d="M13 1.5C19.2984 1.5 24.5 6.81872 24.5 13.5C24.5 20.1813 19.2984 25.5 13 25.5C6.70158 25.5 1.5 20.1813 1.5 13.5C1.5 6.81872 6.70158 1.5 13 1.5Z"
                                stroke="#9DACBD"
                                strokeWidth="3"
                            />
                            <path d="M8 8.5L17.5 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round" />
                            <path d="M17.5 8.5L8 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </div>
                </Modal.Header>
                <Modal.Body className="px-4">
                    <Form onSubmit={handleSubmit} className="pre-register-user-form d-flex flex-column gap-3 ">
                        <div>
                            <label className="form-label pre-register-user-label mb-1">Locación</label>
                            <select
                                className={`form-select pre-register-user-select ${loading ? 'placeholder' : ''}`}
                                name="location"
                                value={formValues.location}
                                onChange={handleChange}
                            >
                                <option selected value="-1">Selecciona la sede</option>
                                {locations?.map((location) => (
                                    <option key={location.id} value={location.id}>
                                        {location.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <input
                                type="text"
                                className={`pre-register-user-input ${loading ? 'placeholder' : ''}`}
                                name="email"
                                value={formValues.email || ""}
                                placeholder="Ingresa el correo electrónico"
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <select
                                className={`form-select pre-register-user-select ${loading ? 'placeholder' : ''}`}
                                name="membership"
                                value={formValues.membership}
                                onChange={handleChange}
                            >
                                <option selected>Membresías</option>
                                {memberships?.map((location) => (
                                    <option key={location.id} value={location.id}>
                                        {location.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="pre-register-user-label text-center">
                            Aquí administrarás y asignarás el plan de accesos e iniciación de tu usuario
                        </div>

                        <div>
                            <select
                                className={`form-select pre-register-user-select ${loading ? "placeholder" : ""}`}
                                name="plan"
                                value={formValues.plan || ""}
                                onChange={handleChange}
                            >
                                <option value="">Planes</option>
                                {plans?.map((plan) => (
                                    <option key={plan.id} value={plan.id}>
                                        {plan.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <input
                                type={formValues.start_date ? "date" : "text"}
                                className={`pre-register-user-input ${loading ? "placeholder" : ""}`}
                                name="start_date"
                                value={formValues.start_date || ""}
                                placeholder="Fecha de inicio"
                                onFocus={(e) => (e.target.type = "date")}
                                onBlur={(e) => {
                                    if (!formValues.start_date) e.target.type = "text";
                                }}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="pre-register-user-line"></div>

                        <div>
                            <label className="form-label pre-register-user-label mb-1">Fecha de pago</label>
                            <input
                                type="date"
                                className={`pre-register-user-input ${loading ? 'placeholder' : ''}`}
                                name="payment_date"
                                value={formValues.payment_date || ""}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="d-flex flex-row justify-content-center align-items-center gap-1">
                            <div className="w-50">
                                <label className="form-label pre-register-user-label mb-1">Valor del Plan</label>
                                <input
                                    type="number"
                                    className={`pre-register-user-input ${loading ? 'placeholder' : ''}`}
                                    name="plan_value"
                                    value={formValues.plan_value || ""}
                                    placeholder="automático"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="w-50">
                                <label className="form-label pre-register-user-label mb-0">
                                    % de DSCTO.
                                    <Popover
                                        title="Descuento"
                                        description="Ingresa el porcentaje de descuento que deseas aplicar, si lo requieres. Este es un campo opcional. El valor se calcula automáticamente sobre el total y se actualiza en el resumen de pago."
                                    >
                                        <svg className="ms-1" width="17" height="17" viewBox="0 0 17 17" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="8.5" cy="8.5" r="8.5" fill="#3177BE" />
                                            <path
                                                d="M8.68771 4.28522C9.89233 4.28522 11.0243 4.75355 11.8758 5.60505C12.7273 6.45655 13.1957 7.58855 13.1957 8.79317C13.1957 9.9978 12.7273 11.1298 11.8758 11.9813C11.0243 12.8328 9.89233 13.3011 8.68771 13.3011C7.48308 13.3011 6.35108 12.8328 5.49958 11.9813C4.64808 11.1298 4.17975 9.9978 4.17975 8.79317C4.17975 7.58855 4.64808 6.45655 5.49958 5.60505C6.35108 4.75355 7.48308 4.28522 8.68771 4.28522ZM8.68771 3.58398C5.81013 3.58398 3.47852 5.9156 3.47852 8.79317C3.47852 11.6707 5.81013 14.0024 8.68771 14.0024C11.5653 14.0024 13.8969 11.6707 13.8969 8.79317C13.8969 5.9156 11.5653 3.58398 8.68771 3.58398Z"
                                                fill="white" />
                                            <path
                                                d="M8.52797 5.64C8.90664 5.64 9.24264 5.696 9.53597 5.808C9.8293 5.92 10.0586 6.08533 10.224 6.304C10.3893 6.51733 10.472 6.78133 10.472 7.096C10.472 7.416 10.4026 7.68 10.264 7.888C10.1306 8.09067 9.9493 8.24533 9.71997 8.352C9.49064 8.45333 9.2373 8.52 8.95997 8.552L8.90397 9.304H7.90397L7.91197 8.096C8.2693 8.05333 8.54664 7.99733 8.74397 7.928C8.94664 7.85333 9.08797 7.76 9.16797 7.648C9.2533 7.536 9.29597 7.40267 9.29597 7.248C9.29597 7.09867 9.26397 6.97333 9.19997 6.872C9.1413 6.77067 9.05064 6.69333 8.92797 6.64C8.8053 6.58667 8.64797 6.56 8.45597 6.56C8.17864 6.56 7.9573 6.64 7.79197 6.8C7.62664 6.95467 7.5253 7.176 7.48797 7.464L6.44797 7.064C6.51197 6.78667 6.6293 6.54133 6.79997 6.328C6.97064 6.10933 7.1973 5.94133 7.47997 5.824C7.76797 5.70133 8.1173 5.64 8.52797 5.64ZM8.41597 9.84C8.62397 9.84 8.7893 9.896 8.91197 10.008C9.03464 10.12 9.09597 10.2693 9.09597 10.456C9.09597 10.648 9.03464 10.8 8.91197 10.912C8.7893 11.0187 8.62397 11.072 8.41597 11.072C8.20797 11.072 8.04264 11.0187 7.91997 10.912C7.7973 10.8 7.73597 10.648 7.73597 10.456C7.73597 10.2693 7.7973 10.12 7.91997 10.008C8.04264 9.896 8.20797 9.84 8.41597 9.84Z"
                                                fill="white" />
                                        </svg>
                                    </Popover>
                                </label>
                                <input
                                    type="number"
                                    className={`pre-register-user-input ${loading ? 'placeholder' : ''}`}
                                    name="plan_discount"
                                    value={formValues.plan_discount || ""}
                                    placeholder="Escribe aquí"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div>
                            <label className="form-label pre-register-user-label mb-1">Total</label>
                            <input
                                type="text"
                                className={`pre-register-user-input ${loading ? 'placeholder' : ''}`}
                                name="plan_total_value"
                                value={formValues.plan_total_value || ""}
                                placeholder="automático"
                                onChange={handleChange}
                                readOnly
                            />
                        </div>

                        <div>
                            <label className="form-label pre-register-user-label mb-1">Método de pago</label>
                            <select
                                className={`form-select pre-register-user-select ${loading ? 'placeholder' : ''}`}
                                name="payment"
                                value={formValues.payment}
                                onChange={handleChange}
                            >
                                <option selected>
                                    Selecciona un método de pago
                                </option>
                                {[
                                    { id: 10, name: "Tarjeta de Crédito o Débito" },
                                    { id: 20, name: "Transferencia" },
                                    { id: 30, name: "Efectivo" },
                                    { id: 40, name: "No registra" },
                                    { id: 50, name: "Otros" }
                                ].map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {Number(formValues.payment) === 50 && (
                            <div>
                                <label className="form-label pre-register-user-label mb-1">Otro método de pago</label>
                                <input
                                    type="text"
                                    className={`pre-register-user-input ${loading ? 'placeholder' : ''}`}
                                    placeholder="Escribe aquí"
                                    name="other_payment"
                                    value={formValues?.other_payment || ""}
                                    onChange={handleChange}
                                />
                            </div>
                        )}

                        <div className="pre-register-user-line"></div>

                        <button
                            type="submit"
                            className="button w-50 align-self-center pre-register-user-button"
                            disabled={sending}
                        >
                            {sending ? (
                                <span className="spinner-border spinner-border-sm " role="status"
                                    aria-hidden="true"></span>
                            ) : (<>
                                Registrar
                            </>)}
                        </button>
                    </Form>
                </Modal.Body>
            </Modal>
            {showAlert && alertConfig && <InlineModal {...alertConfig} />}
        </>
    );
};

export default PreRegisterUserModal;
